exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\n * 블록 연결 창 높이(2026-10-12 직원 의견, 한솔비 \"페이지 축소해야만 아래까지 보여요\").\n *   노트북처럼 화면이 낮으면 목록 아래가 잘렸다. 창 높이를 화면 안으로 묶고, 가운데(번호·목록)만 스크롤한다(robot-connect.jsx S.scroll).\n *   190px = 위 여백 100px + 머리 50px + 테두리 8px + 아래 여백. 화면이 낮을 때(760px 이하)는 위 여백을 줄여 한 줄이라도 더 보이게.\n *   되돌리기: robot-connect.jsx 에서 이 파일 import 와 className(panel·body)을 빼면 예전처럼 한 덩어리.\n */\n.robot-connect_body_2RFFp {\n    max-height: calc(100vh - 190px);\n}\n@media (max-height: 760px) {\n    /* group-number-modal.css 의 margin: 100px auto 보다 우선(두 번 써서 우선순위 높임) */\n    .robot-connect_panel_1vdTE.robot-connect_panel_1vdTE {\n        margin-top: 1.5rem;\n        margin-bottom: 1rem;\n    }\n    .robot-connect_body_2RFFp {\n        max-height: calc(100vh - 110px);\n    }\n}\n", ""]);

// exports
exports.locals = {
	"body": "robot-connect_body_2RFFp",
	"panel": "robot-connect_panel_1vdTE"
};